const colors = {
  Orange: '#ff780d',
  Blue: '#1b82be',
  'Neutral Blue': '#597089',
  'Mid Blue': '#529eca',
  'Light Blue': '#dde9f7',
  'Light Blue 2': '#f0f6fa',
  'Dark Blue': '#1573aa',
  'Dark Neutral 1': '#3c4757',
  'Mid Neutral 1': '#6e767f',
  'Mid Neutral 2': '#9ba1ae',
  'Mid Neutral 3': '#d7dbe2',
  'Light Neutral 1': '#e3e5ea',
  'Light Neutral 2': '#f4f5f7',
  'Light Neutral 3': '#f9f9fa',
  Yellow: '#fab666',
  'Dark Yellow': '#e58d27',
  'Light Yellow': '#fff8f0',
  Red: '#eb5757',
  'Light Red': '#fef7f7',
  Green: '#2ea970',
  'Dark Green': '#129558',
  White: '#ffffff',
  Carat: '#cfd4dc',
};

export default colors;
